import { faBell, faEdit, faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { BsButton } from '../../collection/bootstrap/BootstrapComponents';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import EstadoHojaDeFichaje from '../../components/project/EstadoHojaDeFichaje';
import { apiForm, apiGet, apiUrl, getSession } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';
import { notify, swalertConfirm } from '../../utils/notifications';

export default function HojasDeFichaje(props) {

    // default filter
    const usuario = getSession();
    const defaultFilter = {};
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("hojasdefichaje/table", filter);
    };

    // render
    return <>
        <h2>Hojas de fichaje</h2>
        <TableHandler
            onUpdate={updateData}>
            <ValidacionFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectFechas selectFechasMes
                selectDepartamento={usuario.permisoAdmin}
                selectTrabajador />
            <HojasDeFichajeTable />
        </TableHandler>
    </>;
}

function HojasDeFichajeTable(props) {
    // reminder
    const remind = async id => {
        if (await swalertConfirm("¿Enviar recordatorio?", "Se enviará un correo electrónico al trabajador para recordarle que debe firmar el documento.")) {
            if (await apiGet(`hojasDeFichaje/reminder/${id}`)) {
                notify("Recordatorio enviado", 'success');
            }
        }
    }

    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreTrabajador),
            format: row => row.NombreTrabajador,
            sortable: true
        },
        {
            name: "Mes",
            selector: row => row.Mes,
            format: row => moment(row.Mes).format("MM / yyyy"),
            sortable: true
        },
        {
            name: "Estado",
            selector: row => row.Cambiado ? 1 : row.Firmado ? 3 : row.Generado ? 2 : 0,
            format: row => <EstadoHojaDeFichaje cambiado={row.Cambiado} firmado={row.Firmado} generado={row.Generado} size="lg" />,
            sortable: true
        }
    ];

    // table buttons
    const btnVer = row => <a href={apiUrl(`pdfs/view/${row.Id}`)}><BsButton variant="warning" title="Ver documento" size="sm"><FontAwesomeIcon icon={faFile} /></BsButton></a>;
    const btnRecordatorio = row => <BsButton variant="info" title="Enviar recordatorio" size="sm" onClick={() => remind(row.Id)}><FontAwesomeIcon icon={faBell} /></BsButton>;
    const btnRevisar = row => <LinkContainer to={`/supervisar/fichajes/${row.Trabajador}/${moment(row.Mes).format("yyyy-MM")}`}><BsButton variant="secondary" title="Revisar fichajes" size="sm"><FontAwesomeIcon icon={faEdit} /></BsButton></LinkContainer>;
    const buttons = row => <>
        {row.Cambiado ? <>
            {btnVer(row)}
            {btnRevisar(row)}
        </> : row.Firmado ? <>
            {btnVer(row)}
        </> : row.Generado ? <>
            {btnVer(row)}
            {btnRecordatorio(row)}
        </> : <>
            {btnRevisar(row)}
        </>}
    </>;

    // render
    return <>
        <DataTable responsive columns={columns} data={props.data} buttons={buttons} pagination />
    </>;
}

